import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useRouteMatch, useHistory } from "react-router-dom";

import { Form, Input , Radio } from 'antd';
import { Assets } from '../../../../assets/Assets'
import { RpmStatusTriangle, ArrowLeft, RightArrowIconOriginal } from '../../../../assets/Logos/Icons'

function PatientLatestVitals() {
    let reduxData = useSelector(state => state);
    let vitalsdata =
    reduxData.rpmreducer.patientsvital &&
    reduxData.rpmreducer.patientsvital.data[0];
    let classNames = {
        Normal: { tile: "normaltile" },
        Abnormal: { tile: "abnormaltile" },
        Critical: { tile: "criticaltile" }
    }
    let getDataFromVitals = (itemName, extension, ifEmpty) => {

        if (vitalsdata && vitalsdata[itemName]) {
          if (extension) {
            return vitalsdata[itemName] + extension
          } else {
    
            return vitalsdata[itemName]
          }
    
        }
        else if (ifEmpty) {
          return "NA"
        }
        else {
          return ""
        }
    
      }
    var bmi = (((vitalsdata?.weightValue.split(" ")[0])/(vitalsdata?.heightValue.split(" ")[0]*vitalsdata?.heightValue.split(" ")[0]))*10000);
		
return (
    <div className={`white-container  ${classNames[vitalsdata?.overallstatus!=undefined?vitalsdata.overallstatus:"Normal"]?.tile}`}>


    <div className="rpm-dashboard-tile_body_consultation" style={{padding:"10px",lineHeight:"1.9"}}>


    <div className="rpm-dashboard-tile_body_item">
        <span className="rpm-dashboard-tile_body_item_question">
            Weight:
        </span>
        <span className="rpm-dashboard-tile_body_item_answer">

            {getDataFromVitals("weightValue","","NA")}{" "}

        </span>
        </div>
        <div className="rpm-dashboard-tile_body_item">
        <span className="rpm-dashboard-tile_body_item_question">
            Height:
        </span>
        <span className="rpm-dashboard-tile_body_item_answer">

            {getDataFromVitals("heightValue","","NA")}{" "}

        </span>
        </div>
        <div className="rpm-dashboard-tile_body_item">
        <span className="rpm-dashboard-tile_body_item_question">
            BMI:
        </span>
        <span className="rpm-dashboard-tile_body_item_answer">

           {bmi?bmi:"NA"}

        </span>
        </div>

        <div className="rpm-dashboard-tile_body_item">
        <span className="rpm-dashboard-tile_body_item_question">
            Pulse:
        </span>
        <span className="rpm-dashboard-tile_body_item_answer">

            {
            getDataFromVitals("pulserate", " bpm", "-")
            }
            {/* {vitalsdata?.pulserate
            ? vitalsdata.pulserate + " bpm"
            : "-"}{" "} */}
        </span>
        <span className="rpm-dashboard-tile_body_item_time">


            {
            getDataFromVitals("puldate", "", "") && `(${getDataFromVitals("puldate", "", "")})`
            }
            {/* 
            {vitalsdata?.puldate
            ? " (" + vitalsdata.puldate + ") "
            : ""} */}
        </span>
        <span className="rpm-dashboard-tile_body_item_status">
            {vitalsdata?.pulserate ? (
            <RpmStatusTriangle
                variant={
                getDataFromVitals("pulseratetatus", "", "") ?
                    vitalsdata.pulseratetatus
                    : "normal"
                }
                size="13"
                direction={vitalsdata.pulseratetatus==="critical"?"up":"down"}
            />
            ) : (
            ""
            )}
        </span>
        </div>
        <div className="rpm-dashboard-tile_body_item">
        <span className="rpm-dashboard-tile_body_item_question">
            Temperature:
        </span>
        <span className="rpm-dashboard-tile_body_item_answer">
            {getDataFromVitals("body_temp", " °C", "-")}
            {/* {vitalsdata?.body_temp ? vitalsdata.body_temp + " C" : "-"}{" "} */}
        </span>
        <span className="rpm-dashboard-tile_body_item_time">

            {getDataFromVitals("body_tempdate", "", "") && `(${getDataFromVitals("body_tempdate", "", "")})`}
            {/* {vitalsdata?.body_tempdate
            ? " (" + vitalsdata.body_tempdate + ") "
            : ""} */}
        </span>
        <span className="rpm-dashboard-tile_body_item_status">
            {vitalsdata?.body_tempstatus ? (
            <RpmStatusTriangle
                variant={
                getDataFromVitals("body_tempstatus", "", "")
                    ? vitalsdata.body_tempstatus
                    : "normal"
                }
                size="13"
                direction={vitalsdata.body_tempstatus==="critical"?"up":"down"}
            />
            ) : (
            ""
            )}
        </span>
        </div>

        <div className="rpm-dashboard-tile_body_item">
        <span className="rpm-dashboard-tile_body_item_question">
            Glucose:
        </span>
        <span className="rpm-dashboard-tile_body_item_answer">

            {
            getDataFromVitals("glucose", " mmol/L", "-")
            }
            {/* 
            {vitalsdata?.glucose
            ? vitalsdata.glucose + " mmol/L"
            : "-"}{" "} */}
        </span>
        <span className="rpm-dashboard-tile_body_item_time">
            {getDataFromVitals("blood_sugardate", "", "") && `(${getDataFromVitals("blood_sugardate", "", "")})`}
            {/* {vitalsdata?.blood_sugardate
            ? " (" + vitalsdata.blood_sugardate + ") "
            : ""} */}
        </span>
        <span className="rpm-dashboard-tile_body_item_status">
            {vitalsdata?.blood_sugerstatus ? (
            <RpmStatusTriangle
                variant={
                getDataFromVitals("blood_sugerstatus", "", "")
                    ? vitalsdata.blood_sugerstatus
                    : "normal"
                }
                size="13"
                direction={vitalsdata.blood_sugerstatus==="critical"?"up":"down"}
            />
            ) : (
            ""
            )}
        </span>
        </div>

        <div className="rpm-dashboard-tile_body_item">
        <span className="rpm-dashboard-tile_body_item_question">
            SpO2:
        </span>
        <span className="rpm-dashboard-tile_body_item_answer">
            {getDataFromVitals("blood_oxygen", " %", "-")}
            {/* {vitalsdata?.blood_oxygen
            ? vitalsdata.blood_oxygen + " %"
            : "-"}{" "} */}
        </span>
        <span className="rpm-dashboard-tile_body_item_time">
            {getDataFromVitals("blood_oxygendate", "", "") && `(${getDataFromVitals("blood_oxygendate", "", "")})`}
            {/* {vitalsdata?.blood_oxygendate
            ? " (" + vitalsdata.blood_oxygendate + ") "
            : ""} */}
        </span>
        <span className="rpm-dashboard-tile_body_item_status">
            {vitalsdata?.blood_oxygenstatus ? (
            <RpmStatusTriangle
                variant={
                getDataFromVitals("blood_oxygenstatus", "", "")
                    ? vitalsdata.blood_oxygenstatus
                    : "normal"
                }
                size="13"
                direction={vitalsdata.blood_oxygenstatus==="critical"?"up":"down"}
            />
            ) : (
            ""
            )}
        </span>
        </div>

        <div className="rpm-dashboard-tile_body_item">
        <span className="rpm-dashboard-tile_body_item_question">
            BP:
        </span>
    
        <span className="rpm-dashboard-tile_body_item_status">
        {vitalsdata?.systolicstatus ? (
            <RpmStatusTriangle
            variant={
                vitalsdata?.systolicstatus != ""
                ? vitalsdata.systolicstatus
                : "normal"
            }
            size="13"
            direction={vitalsdata.systolicstatus==="critical"?"up":"down"}
            />
        ) : (
            ""
        )}
            {/* {vitalsdata?.systolicstatus ? (
            <RpmStatusTriangle
                variant={
                vitalsdata.systolicstatus != ""
                    ? vitalsdata.systolicstatus
                    : "normal"
                }
                size="13"
                direction="up"
            />
            ) : (
            ""
            )} */}
        </span>
        
        <span className="rpm-dashboard-tile_body_item_answer">

        {vitalsdata?.systolic
            ? vitalsdata?.systolic
            : "" }{vitalsdata?.diastolic
            ? "/"+vitalsdata?.diastolic
            : ""}
        </span>
        <span className="rpm-dashboard-tile_body_item_status">
        {vitalsdata?.diastolicstatus ? (
            <RpmStatusTriangle
            variant={
                vitalsdata?.diastolicstatus != ""
                ? vitalsdata?.diastolicstatus
                : "normal"
            }
            size="13"
            direction={vitalsdata.diastolicstatus==="critical"?"up":"down"}
            />
        ) : (
            ""
        )}
        </span>

        <span className="rpm-dashboard-tile_body_item_answer">
            {vitalsdata?.systolic && vitalsdata?.diastolic
            ? " mmHg"
            : "NA"}
        </span>
        <span className="rpm-dashboard-tile_body_item_time">
            {vitalsdata?.date ? " (" + vitalsdata.date + ") " : ""}
        </span>
        </div>

        <div className="rpm-dashboard-tile_body_item">
        <span className="rpm-dashboard-tile_body_item_question">
            ECG:
        </span>
        <span className="rpm-dashboard-tile_body_item_answer">
            {vitalsdata?.ecgheart_rate
            ? vitalsdata.ecgheart_rate +" bpm"
            : "NA"}
        </span>
        <span className="rpm-dashboard-tile_body_item_time">
            {vitalsdata?.ecgdate
            ? " (" + vitalsdata.ecgdate + ") "
            : ""}
        </span>
        <span className="rpm-dashboard-tile_body_item_status">
            {vitalsdata?.ecgheartratestatus ? (
            <RpmStatusTriangle
                variant={
                vitalsdata.ecgheartratestatus != ""
                    ? vitalsdata.ecgheartratestatus
                    : "normal"
                }
                size="13"
                direction={vitalsdata.ecgheartratestatus==="critical"?"up":"down"}
            />
            ) : (
            ""
            )}
        </span>
        </div>


    </div>

    </div>
)
}
export default PatientLatestVitals
